module.exports = __webpack_public_path__ + "img/default.9aad1c0b.png";